import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { BloqueioDetectado } from './venda-liberacao.regras';

export interface VdLiberacaoDialogData {
    /** Os bloqueios detectados ao salvar, na ordem da story (desconto, crédito, atraso). */
    bloqueios: BloqueioDetectado[];
}

/** A saída "Liberar agora" (§6.5.1): a credencial do supervisor e a justificativa. */
export interface VdLiberacaoDialogResult {
    email: string;
    senha: string;
    observacao: string | null;
}

/**
 * "Liberação necessária" (§6.5.1).
 *
 * A credencial é do SUPERVISOR, digitada na frente do vendedor, e vai UMA vez, dentro do request
 * de salvamento: quem confere é o orquestrador (POST /Auth) e a senha não fica em lugar nenhum
 * da tela depois que o diálogo fecha. Fechar sem liberar devolve `undefined`, e o shell não
 * salva — o bloqueio continua de pé.
 *
 * "Liberar depois" (solicitação remota) é a fase 2 da story e não existe aqui.
 */
@Component({
    selector: 'app-vd-liberacao-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
    ],
    templateUrl: './vd-liberacao-dialog.component.html',
    styleUrls: ['./vd-liberacao-dialog.component.css'],
})
export class VdLiberacaoDialogComponent {
    public email = '';
    public senha = '';
    public observacao = '';
    public mostrarSenha = false;

    constructor(
        public dialogRef: MatDialogRef<VdLiberacaoDialogComponent, VdLiberacaoDialogResult>,
        @Inject(MAT_DIALOG_DATA) public data: VdLiberacaoDialogData,
    ) {}

    public get podeLiberar(): boolean {
        return this.email.trim().length > 0 && this.senha.length > 0;
    }

    public liberar(): void {
        if (!this.podeLiberar) return;

        this.dialogRef.close({
            email: this.email.trim(),
            senha: this.senha,
            observacao: this.observacao.trim() || null,
        });
    }

    public cancelar(): void {
        this.dialogRef.close();
    }
}
